import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';

import { AttentionModalComponent } from '../attention-modal/attention-modal.component';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AttentionModalComponent, RktButtonDirective],
})
export class SuccessModalComponent {
  actionName!: string;

  type!: 'Recipient' | 'Employee' | 'FinancialAccount' | 'Transaction' | 'Customer';

  customTitle = '';

  get typeText() {
    switch (this.type) {
      case 'Employee':
        return 'Team Member';
      case 'Recipient':
        return 'Recipient Account';
      case 'FinancialAccount':
        return 'Financial Account';
      case 'Transaction':
        return 'Transaction';
      case 'Customer':
        return 'Customer Account';
      default:
        return this.type;
    }
  }

  constructor(public activeModal: ActiveModal) {}
}
